import { useSelector } from 'react-redux';

import {
  CashierConfiguration,
  selectCashierConfiguration,
} from '@cashier/cashier-data-access';

export const useCashierConfiguration = (): CashierConfiguration => {
  return useSelector(selectCashierConfiguration);
};
